<template>
  <div class="window" :style="{ top: y + 'px', left: x + 'px', position: 'absolute', zIndex: 9999 }">
    <ul class="menu">
      <li @click="openApp">Open</li>
      <!-- <li @click="renameIcon">Rename</li> -->
      <li 
        :style="!icon.delete ? { color: 'gray', pointerEvents: 'none' } : {}"
        @click="icon.delete && deleteIcon()"
      >
        Delete
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  x: Number,
  y: Number,
  icon: Object,
  onClose: Function,
  onDeleteIcon: Function,
  onShowConfirmDialog: Function,
});

function openApp() {
  props.onClose();
  alert(`Opening ${props.icon.label}`);
}

function renameIcon() {
  props.onClose();
  const newName = prompt('New name:', props.icon.label);
  if (newName !== null) props.icon.label = newName;
}

function deleteIcon() {
  props.onClose();
  props.onShowConfirmDialog({
    message: `Are you sure you want to delete ${props.icon.label}?`,
    onConfirm: () => props.icon.delete(),
  });
}
</script>

<style scoped>
.context-menu {
  background: white;
  border: 2px solid black;
  box-shadow: 2px 2px 0 black;
  z-index: 9999;
}

.menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li {
  padding: 4px 12px;
}

.menu li:hover {
  background: #000080;
  color: white;
}
</style>
